import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import TopAdBar from "./TopAdBar";
import NavBar from "./NavBar";
export const CompleteNav = (props)=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative bg-primary xlg:bg-transparent",
        children: [
            /*#__PURE__*/ _jsx(TopAdBar, {
                ...props
            }),
            /*#__PURE__*/ _jsx(NavBar, {
                ...props
            })
        ]
    });
};
export default CompleteNav;

//# sourceMappingURL=CompleteNav.js.map